import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { EnumMessageRole } from '../../enums/message-role.enum';
import { IChatMessage } from '../../interfaces/chat-message.interface';
import {
  IInformationReference,
  isInformationReference,
  isKnowledgeDocumentReference
} from '../../interfaces/message-reference.interface';
import {
  documentLabel,
  IKnowledgeDocumentIcon,
  knowledgeDocumentIcon
} from '../../utils/knowledge-document-icon.util';

interface IDocumentReferenceView {
  id: string;
  label: string;
  icon: IKnowledgeDocumentIcon;
}

@Component({
  selector: 'sgt-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent implements OnInit, OnChanges {
  @Input() message!: IChatMessage;
  @Input() isTyping = false;
  @Output() copyMessage = new EventEmitter<IChatMessage>();

  copied = false;
  documentReferences: IDocumentReferenceView[] = [];
  informationReferences: IInformationReference[] = [];

  ngOnInit(): void {
    this.buildDocumentReferences();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.message && !changes.message.firstChange) {
      this.buildDocumentReferences();
    }
  }

  trackByReferenceId(_: number, reference: { id: string }): string {
    return reference.id;
  }

  onCopy(): void {
    this.copyMessage.emit(this.message);
    this.copied = true;
    setTimeout(() => (this.copied = false), 2000);
  }

  private buildDocumentReferences(): void {
    this.documentReferences = (this.message?.references ?? [])
      .filter(isKnowledgeDocumentReference)
      .map(reference => ({
        id: reference.id,
        label: documentLabel(reference),
        icon: knowledgeDocumentIcon(reference.detectedMime)
      }));
    this.informationReferences = (this.message?.references ?? []).filter(isInformationReference);
  }

  get isAgent(): boolean {
    return this.message?.role === EnumMessageRole.AGENT;
  }

  get isUser(): boolean {
    return this.message?.role === EnumMessageRole.USER;
  }

  get hasCharts(): boolean {
    return !!this.message?.charts?.length;
  }

  get hasAttachments(): boolean {
    return !!this.message?.attachments?.length;
  }

  get hasBubbleContent(): boolean {
    if (this.isUser) {
      return !!this.message?.content;
    }
    return !!this.message?.htmlContent;
  }

  get formattedTimestamp(): string {
    if (!this.message?.timestamp) {
      return '';
    }

    return new Date(this.message.timestamp).toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}
